import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useUserContext} from '@hconnect/login'
import {useCallback} from 'react'

interface SapPmNotificationEvent {
  name: 'onSapPmNotificationFeature'
  data: {timezone: string}
}

interface CreationStartEvent {
  name: 'onCreationStartEvent'
  data: {uuid: string}
}

interface CreationFinishEvent {
  name: 'onCreationFinishEvent'
  data: {uuid: string}
}

interface UserAdjustsFilterEvent {
  name: 'userAdjustsFilter'
  data: {filterPage: 'events' | 'workOrders' | 'notifications'; filterName?: string}
}

interface UserDownloadsEventsListEvent {
  name: 'userDownloadsEventsList'
}

type ShiftEventsAnalyticsEvent =
  | SapPmNotificationEvent
  | CreationStartEvent
  | CreationFinishEvent
  | UserAdjustsFilterEvent
  | UserDownloadsEventsListEvent

type Params = {
  plantId: string
  country: string
}

export const useTrackShiftEventsAnalytics = ({plantId, country}: Params) => {
  const {loggedUser} = useUserContext()
  const userId = loggedUser?.id

  const trackShiftEventAnalytics = useCallback(
    (event: ShiftEventsAnalyticsEvent) => {
      if (!plantId) return

      const baseData = {
        product: 'cockpit',
        timestamp: new Date().toISOString(),
        userId,
        plantId,
        country
      }

      if ('data' in event) {
        trackEvent(event.name, {...baseData, ...event.data})
      } else {
        trackEvent(event.name, baseData)
      }
    },
    [plantId, country, userId]
  )

  return trackShiftEventAnalytics
}
